import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Terminal, Code2, Zap, Shield, Search, Layers } from 'lucide-react';

export default function ResourceAPI() {
  return (
    <SubpageTemplate 
      title="API Reference"
      subtitle="Programmatic Control"
      description="Integrate the Yacht Labs synthesis engine directly into your existing workflows. Build custom toolchains on top of our core inference API."
      icon={Terminal}
      features={[
        {
          title: "Inference API",
          description: "Trigger technical builds and project architectures via simple REST endpoints.",
          icon: Code2
        },
        {
          title: "Webhooks",
          description: "Receive real-time notifications for build completion, deployment status, and error logs.",
          icon: Zap
        },
        {
          title: "SDKs",
          description: "Official libraries for TypeScript, Python, and Go to accelerate your integrations.",
          icon: Layers
        }
      ]}
    />
  );
}
